/**
 * Pension types that have pension_<type>, pension_<type>_excluded and
 * pension_<type>_total columns in user_profiles_view and get_user_profiles().
 * Used by the Users > Pension Values filter (UserProfile) and the dashboard
 * Pension Statistics tiles (PensionStats). Keep this the only copy.
 */
export const PENSION_TYPE_KEYS = [
  'sipp',
  'personal_pension',
  'group_pension',
  'final_salary',
  'stakeholder',
  'money_purchase',
  'section_32',
  's226',
  'crystallised_dc'
];
